import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import Popper from '@material-ui/core/Popper';

import Options from "./Options/Options";

@connect(store => {
    return {
        files: store.files
    };
})

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            width: "100%"
        }
        this.searchContainerRef = React.createRef();
    }

    render() {
        const { files, projectId, dispatch } = this.props;
        const open = Boolean(this.state.anchorEl);
        const width = this.state.width;
        const inActivities =  files.filters.options.location.value  === 'activities';
        
        const handleClick = () => {
            this.setState({...this.state, anchorEl: this.searchContainerRef.current});
        }
        
        const handleClose = () => {
            this.setState({...this.state, anchorEl: null, width: "100%"});
            if(this.props.onCancel) {
                this.props.onCancel()
            }
        }
        const handlePullDown = () => {
            this.setState({...this.state, anchorEl: null});
            
        }

        const searchedItems = () => {
            return Object.keys(files.filters.options).filter(k => k !== "uploadedDate" ? (k !== "name" && files.filters.options[k].value) : (files.filters.options[k].from.value || files.filters.options[k].to.value)).map(k => {
                const label = files.filters.options[k].label;

                if(k === "location") {
                    return `Location: ${label}`;
                } else if(k === "uploadedBy") {
                    if(inActivities) {
                        return `Collaborator: ${label}`;
                    }
                    return `Uploaded by: ${label}`;
                } else if(k === "workstream") {
                    return `Workstream: ${label}`
                } else if(k === "action") {
                    return `Action: ${label}`
                } else if(k === "task") {
                    return `Task: ${label}`
                } else if(k === "uploadedDate") {
                    if(inActivities) {
                        return `Date Modified: ${files.filters.options[k].from.label}${files.filters.options[k].to.value ? ` to ${files.filters.options[k].to.label}` : ""}`
                    }
                    return `Uploaded Date: ${files.filters.options[k].from.label}${files.filters.options[k].to.value ? ` to ${files.filters.options[k].to.label}` : ""}`
                } else if(k === "comment") {
                    return `Comment: ${files.filters.options[k].value}`
                } else {
                    return k;
                }
            }).join(", ");
        }

        const handleSearch = (e) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {name: e.target.value}});

            const value = e.target.value;
            const width = (value.length +1) * 6 + 'px';

            if (value.length) {
                this.setState({width});
            } else {
                this.setState({width: "100%"});
            }
        }

        const handleSave = () => {
            dispatch({ type: "UPDATE_FILES_FILTERS_UPDATED", boolean: true });
            dispatch({ type: "UPDATE_FILES_SIDEBAR_ACTIVE", menu: {
                id: files.filters.options.location.value,
                label: files.filters.options.location.value
            } });
            
            if(this.props.onClose) {
                this.props.onClose();
            }
            if(this.props.onSearch) {
                this.props.onSearch();
            }
        }

        const handleKeyPress = (e) => {
            if(e.key === "Enter") {
                handleSave();
            }
        }
        const handleCancel =()=>{
            if(this.props.onCancel){
                this.props.onCancel();
                this.setState({width: "100%"});
            }
        }

        return (
            <div class="filesSearchContainer">
                <div class="filesSearchInput" ref={this.searchContainerRef}>
                    <div class="searchForm">
                        <i class="material-icons searchIcon">search</i>
                        {!inActivities && 
                            <input type="text" placeholder={searchedItems().length > 0 ? "" : `Search in Files`} onChange={handleSearch} onKeyPress={handleKeyPress} value={files.filters.options.name ? files.filters.options.name : ""} style={{width: searchedItems().length > 0 && !files.filters.options.name ? 8 : width}} />
                        }
                        {searchedItems().length > 0 && <span class="searchOptionsItem">({searchedItems()})</span>}
                    </div>
                    <a onClick={open ? handlePullDown : handleClick}>
                        <i class="material-icons">arrow_drop_down</i>
                    </a>
                </div>
                <Popper
                    open={open}
                    anchorEl={this.state.anchorEl}
                    placement="bottom-start"
                    style={{zIndex: 100}}
                >
                    <Options onClose={handleClose} projectId={projectId} onSave={handleSave} onCancel={handleCancel}/>
                </Popper>
            </div>
        );
    }
}

export default Search;